import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
	PreloadAllModules,
	provideRouter,
	withEnabledBlockingInitialNavigation,
	withInMemoryScrolling,
	withPreloading
} from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { NgxPermissionsModule } from 'ngx-permissions';
import { requestInterceptor } from 'app/core/interceptors/request.interceptor';
import { toastInterceptor } from 'app/core/interceptors/toast.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { DialogService } from 'primeng/dynamicdialog';
import { DatePipe } from '@angular/common';

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(
			appRoutes,
			withPreloading(PreloadAllModules),
			withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
			withEnabledBlockingInitialNavigation()
		),
		provideHttpClient(withInterceptors([requestInterceptor, toastInterceptor])),
		provideAnimationsAsync(),
		providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
		importProvidersFrom(NgxPermissionsModule.forRoot(), RxReactiveFormsModule),
		MessageService,
		ConfirmationService,
		DialogService,
		DatePipe
	]
};
